import { MutableValue } from "@/modules/api/mutable-value.interface";

export default class PlushieUpgradeRelation implements MutableValue {
  public isNew = true;

  private fCreatedAt?: Date;

  constructor(
    private fId: string,
    private fPlushie: string,
    private fUpgrade: string,
    private fQuantity?: number
  ) {
    [fId, fPlushie, fUpgrade].forEach((arg, index) => {
      if (arg === undefined) {
        throw new Error(`Undefined value passed at position: ${index}`);
      }
    });
  }

  get id(): string {
    return this.fId;
  }

  get createdAt(): Date | undefined {
    return this.fCreatedAt;
  }

  get plushie(): string {
    return this.fPlushie;
  }

  get upgrade(): string {
    return this.fUpgrade;
  }

  get quantity(): number | undefined {
    return this.fQuantity;
  }
}
